import { Box, Skeleton, Stack } from "@mui/material";

import { MapPanel } from "~/modules/map/components/MapPanel";

export function ProjectReviewVisitV2OverviewPanelSkeleton() {
    return (
        <MapPanel>
            <Stack>
                {[1, 2, 3, 4].map(i => (
                    <Stack
                        key={i}
                        sx={theme => ({
                            borderBottom: `1px solid ${theme.palette.divider}`,
                        })}
                        direction="row"
                        padding={2}
                        columnGap={2}
                    >
                        <Skeleton variant="circular" width={24} height={24} />
                        <Skeleton variant="text" width={180} height={24} />
                    </Stack>
                ))}
            </Stack>
            <Box padding={2}>
                <Skeleton variant="rectangular" width="100%" height={40} />
            </Box>
        </MapPanel>
    );
}
